<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MenuCard :menuItems="menuItems" />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";

export default {
    page: {
        title: i18n.t("module.workplace"),
    },
    components: { Layout, PageHeader, MenuCard },
    data() {
        return {
            title: i18n.t("module.workplace"),
            items: [
                {
                    text: i18n.t("module.workplace"),
                    active: true,
                },
            ],
            menuItems: [
                {
                    route: 'Group',
                    label: i18n.t('module.group'),
                    icon: 'mdi-file-tree',
                    color: 'info',
                    core: true,
                },
                {
                    route: 'Company',
                    label: i18n.t('module.company'),
                    icon: 'mdi-factory',
                    color: 'success',
                    core: true,
                },
                {
                    route: 'Department',
                    label: i18n.t('module.department'),
                    icon: 'mdi-sitemap',
                    color: 'primary',
                    core: true,
                },
                {
                    route: 'Office',
                    label: i18n.t('module.office'),
                    icon: 'mdi-desk',
                    color: 'danger',
                    core: true,
                },
                {
                    route: 'Location',
                    label: i18n.t('module.location'),
                    icon: 'mdi-map-marker',
                    color: 'warning',
                    core: true,
                },
                {
                    route: 'Country',
                    label: i18n.t('module.country'),
                    icon: 'mdi-flag',
                    color: 'success',
                    core: false,
                },
                {
                    route: 'State',
                    label: i18n.t('module.state'),
                    icon: 'mdi-map',
                    color: 'warning',
                    core: false,
                },
                {
                    route: 'CompanyType',
                    label: i18n.t('module.companyType'),
                    icon: 'mdi-tag',
                    color: 'info',
                    core: false,
                },
                {
                    route: 'OfficeType',
                    label: i18n.t('module.officeType'),
                    icon: 'mdi-shape',
                    color: 'primary',
                    core: false,
                },
            ],
        };
    },
}
</script>